import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import Home from './components/Home/Home';
import './style.css'
import Login from './components/Login/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import ForgotPassword from './components/Login/ForgotPassword';
import ChangePassword from './components/Login/ChangePassword';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastContainer } from 'react-toastify';

function App() {
  // useEffect(() => {
  //   const init = async () => {
  //     await initializeAuth();
  //   };
  //   init();
  // }, []);

  return (
    <AuthProvider>
       <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to= "/home/dashboard" />} />
            <Route path="/login" element={<Login />} />
            <Route path='/forgot-password' element={ <ForgotPassword/> } />
            <Route path='/change-password' element = {<ChangePassword/>} />
            <Route 
              path='/home/*'
              element={ 
                <ProtectedRoute>
                  <Home/> 
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
        <ToastContainer/>
    </div>

    </AuthProvider>
   
  );
}

export default App;
